export type ActionType =
  | 'SET_LANDING_DATA'
  | 'REQUEST_LANDING_DATA'
  | 'RECEIVED_LANDING_DATA'
  | 'ERROR_LANDING_DATA';

interface ActionProps {
  type: ActionType;
  isFetching?: boolean;
  data?: {} | any;
  error?: any;
  payload?: {} | any;
}

const initialLandingState = {
  isFetching: true,
  data: {},
  error: {},
};

const Landing = (state = initialLandingState, action: Partial<ActionProps>) => {
  switch (action.type) {
    case 'REQUEST_LANDING_DATA': {
      return {
        ...state,
      };
    }

    case 'RECEIVED_LANDING_DATA': {
      const { payload = {} } = action;
      return {
        ...state,
        isFetching: false,
        data: { ...payload },
      };
    }

    case 'ERROR_LANDING_DATA': {
      const { error = {} } = action;
      return {
        ...state,
        isFetching: false,
        error: { ...error },
      };
    }

    default:
      return state;
  }
};

export default Landing;
